import { Injectable } from '@angular/core';

import { tap, Observable, switchMap } from 'rxjs';

import { Invite } from '@shared/invite/models';
import { WebSocketEventsEnum } from '@shared/websocket';
import {
  AccountApiService,
  InvitesQuery,
  InvitesStore,
  SocketService,
} from '@tablesready/frontend-store';

@Injectable()
export class InvitesService {
  constructor(
    private readonly query: InvitesQuery,
    private readonly store: InvitesStore,
    private readonly socketService: SocketService,
    private readonly accountApiService: AccountApiService,
  ) {}

  load(): Observable<Invite[]> {
    return this.accountApiService.getInvites()
      .pipe(tap(invites => this.store.set(invites)));
  }

  selectAll(): Observable<Invite[]> {
    return this.query.selectAll();
  }

  listenToChanges() {
    return this.socketService.getEventStream<void>(WebSocketEventsEnum.invite)
      .pipe(switchMap(() => this.load()));
  }
}
